// extracted by mini-css-extract-plugin
var _1 = "'Roboto', 'Gotham HTF', 'Roboto Mono', monospace";
var _2 = "400";
var _3 = "#849BAA";
var _4 = "#fff";
var _5 = "#003B4A";
var _6 = "#fff";
export { _1 as "fontFamily", _2 as "fontWeight", _3 as "resetButtonBackgroundColor", _4 as "resetButtonTextColor", _5 as "submitButtonBackgroundColor", _6 as "submitButtonTextColor" }
